<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-header">
      <button mat-icon-button routerLink="/users">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h2 class="page-title">Atualizar Usuário</h2>
        <p class="page-subtitle">Altere os dados do usuário selecionado</p>
      </div>
    </div>

    <div class="form-section">
      @if (user !== null) {
        <app-user-form [formData]="user" (loadingChange)="setLoading($event)" />
      }
    </div>

    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/users">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" [disabled]="false" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>
